"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unit = exports.Provider = exports.AttributeType = void 0;
var AttributeType;
(function (AttributeType) {
    AttributeType["NEGATIVE"] = "negative";
    AttributeType["POSITIVE"] = "positive";
    AttributeType["NEUTRAL"] = "neutral";
})(AttributeType || (exports.AttributeType = AttributeType = {}));
var Provider;
(function (Provider) {
    Provider["HAUT"] = "haut";
})(Provider || (exports.Provider = Provider = {}));
var Unit;
(function (Unit) {
    Unit["PERCENTAGE"] = "percentage";
    Unit["YEAR"] = "year";
    Unit["ITA"] = "ita";
    Unit["VALUE"] = "value";
})(Unit || (exports.Unit = Unit = {}));
const normalized = {
    coloring: {
        attribute: 'coloring',
        unit: Unit.VALUE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'coloring',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    color_uniformness: {
        attribute: 'color_uniformness',
        unit: Unit.VALUE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'color uniformness',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    density: {
        attribute: 'density',
        unit: Unit.VALUE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'density',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    curliness: {
        attribute: 'curliness',
        unit: Unit.VALUE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'curliness',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    clinical_frizziness: {
        attribute: 'clinical_frizziness',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'clinical frizziness',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    clinical_damage: {
        attribute: 'clinical_damage',
        unit: Unit.PERCENTAGE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'clinical damage',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    volume: {
        attribute: 'volume',
        unit: Unit.VALUE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'volume',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    length: {
        attribute: 'length',
        unit: Unit.VALUE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'length',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
    color: {
        attribute: 'color',
        unit: Unit.VALUE,
        providers: [Provider.HAUT],
        parentAttributeType: AttributeType.POSITIVE,
        haut: {
            attribute: 'color',
            type: AttributeType.POSITIVE,
            scale: {
                min: 0,
                max: 100,
            },
        },
    },
};
const haut = {
    algorithm_version_id: {
        '70': normalized.coloring.attribute,
        '71': normalized.color_uniformness.attribute,
        '72': normalized.density.attribute,
        '74': normalized.curliness.attribute,
        '77': normalized.clinical_frizziness.attribute,
        '78': normalized.clinical_damage.attribute,
        '79': normalized.volume.attribute,
        '80': normalized.length.attribute,
        '81': normalized.color.attribute,
    },
};
exports.default = {
    normalized,
    haut,
};
